import React, { useLayoutEffect, useState } from "react";
import "./FavouriteDashboard.css";
import share_1 from "../../../images/share_1.png";
import share_2 from "../../../images/share_2.png";
import share_3 from "../../../images/share_3.png";
import share_4 from "../../../images/share_4.png";
import share_5 from "../../../images/share_5.png";
import edit_1 from "../../../images/edit_1.png";
import del_1 from "../../../images/del_1.png";
import FBChart1 from "./FBchart1";
import GrandChart from "./GrandChart";
import AccountChart from "./AccountChart/AccountChart";
import RiskChart from "./RiskChart/RiskChart";
import AverageChart from "./AverageChart/AverageChart";
import CurrentDayChart from "./CurrentDayChart/CurrentDayChart";
import CurrentMonthChart from "./CurrentMonthChart/CurrentMonthChart";
import CalenderChart from "./CalenderChart/CalenderChart";
import DayTotalChart from "./DayTotalChart/DayTotalChart";
import HttpClient from "../../../utils/HttpClient";
import toast from "react-hot-toast";
import { useUserData } from "../../../Providers/UserWrapper";

const FavouriteDashboard = () => {
  const { setIsLoading } = useUserData();

  const fetchProjects = async () => {
    try {
      setIsLoading(true);
      const res = await HttpClient.requestData("dashboard/init", "POST", {});
      console.log("init my fav dashboard: ", res);
      if (res && res?.widgets?.length > 0) {
        console.log("fav init res: ", res);
      } else {
        console.log("error", res);
        toast.error("failed to load widgets data");
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    } finally {
      setIsLoading(false);
    }
  };

  useLayoutEffect(() => {
    fetchProjects();
  }, []);

  return (
    <div className="dashboard-page-fb">
      <div className="left-side-fb d-none">
        <h3 className="status-tl">Status</h3>
        <div className="logo-task-fb">
          <img src={share_1} alt="lg" />
          <h3>Calendar</h3>
        </div>
        <div className="logo-task-fb">
          <img src={share_2} alt="lg" />
          <h3>Risk management</h3>
        </div>
        <div className="logo-task-fb">
          <img src={share_3} alt="lg" />
          <h3>Prediction/ Forecasting</h3>
        </div>
        <div className="logo-task-fb">
          <img src={share_4} alt="lg" />
          <h3>Budget & Financials</h3>
        </div>
        <div className="logo-task-fb">
          <img src={share_5} alt="lg" />
          <h3>Chat monitor</h3>
        </div>
      </div>
      <div className="right-side-main">
        <h1 className="right-tl-fb">MY FAVORITE DASHBOARD PANEL</h1>
        <div className="right-contents-fb">
          <div className="left-charts-fb">
            <div>
              <GrandChart />
            </div>
            <div className="fav-middle-wrp">
              {/* 2 */}
              <AccountChart />
              {/* <RiskChart /> */}
            </div>
            <AverageChart />
            <div className="chats-vt-wrp">
              {/* <DayTotalChart /> */}
              <RiskChart />
            </div>
          </div>
          <div className="right-charts-fb">
            <div className="chats-vt-wrp">
              <CurrentDayChart />
            </div>
            <div className="chats-vt-wrp">
              <CurrentMonthChart />
            </div>
            <div className="chats-vt-wrp">
              <CalenderChart />
            </div>
            <div className="chats-vt-wrp">
              <DayTotalChart />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FavouriteDashboard;
